// Flagsmith configuration
export const FLAGSMITH_ENV_ID =
  import.meta.env.VITE_FLAGSMITH_ENV_ID ?? 'JPhMPEHYmrnTR3hoSfq2Td';
import FeatureFlags from './feature-flags';

export const FLAGSMITH_DEFAULT_FLAGS: Record<string, { enabled: boolean, value: boolean | string | number | null, id: number }> = {
  // Define any default flag values here that should be used before Flagsmith initializes
  [FeatureFlags.WEBHOOK_ROUTING]: { enabled: true, value: true, id: 1 },
};